import type { ApolloError, OperationVariables, WatchQueryOptions } from '@apollo/client';
import { useApolloClient } from '@apollo/client';
import { isNull, isUndefined } from 'lodash-es';
import { useCallback, useRef } from 'react';
import type { Subscription } from 'zen-observable-ts';

export function useFetchQuery<T = unknown, TVariables extends OperationVariables = OperationVariables>(options: WatchQueryOptions<TVariables, T> & { onError?: (error: ApolloError) => void }) {
  const client = useApolloClient();

  const subscriptionRef = useRef<{ subscription: Subscription | null }>({ subscription: null });

  return useCallback(async (variables?: TVariables) => {
    return new Promise<T>((resolve, reject) => {
      if (!isNull(subscriptionRef.current.subscription)) {
        subscriptionRef.current.subscription.unsubscribe();
      }
      subscriptionRef.current.subscription = client.watchQuery<T, TVariables>({
        ...options,
        variables: variables ?? options.variables,
      }).subscribe(
        ({ data, error }) => {
          if (!isUndefined(error)) {
            options.onError?.(error);
            return reject();
          }

          return resolve(data);
        },
        options.onError,
      );
    });
  }, [client, options]);
}
